import { SportParser } from "../parser";
import { sportMapperFactory, liveCountMapper, preLiveCountMapper, todayCountMapper, SportsMapper } from "../mapper";
import { SportsRetriever, FavoritesRetriever, SportPushesRetriever, LiveStreamingRetriever, LiveStreamingBaseRetriever, TodayLiveStreamingRetriever, SportsBaseRetriever, TodaySportsRetriever } from "../retriever";
import { liveSportBFFQueryFactory, liveSportApiQueryFactory, preLiveSportApiQueryFactory, preLiveSportBFFQueryFactoryConstructor, todaySportApiQueryFactory, todaySportBFFQueryFactory, liveLiveStreamingQueryFactory, upcomingLiveStreamingQueryFactory, todayLiveStreamingQueryFactory } from "../queries";
import { BFFGateway, SportDataGateway, GlobalConfig } from "sb-bff-integration";
import { internalMessageBus } from "sb-internal-msg-bus";
import { Cookies } from "sb-helpers";
import { MessageBus, Clock, MessageSender, State, queryType, TimeZoneObservable } from "../../../common";
import { liveStreamingMode, defaultItemForSportMode } from "../sportConfig";
export var getTimeZoneObservable = function () { return new TimeZoneObservable(getMessageBus()); };
export var sportsRetrieversFactory = function (cfg, dict, timeZoneObservable) {
    var sportsRetriever = getSportsRetriever(cfg, timeZoneObservable);
    var retrievers = [sportsRetriever];
    if (cfg.enableFavorites) {
        retrievers.push(new FavoritesRetriever(getMessageBus(), cfg.isFavoritesFirst, cfg.blockId, dict, Cookies));
    }
    if (cfg.enableLiveStreaming) {
        retrievers.push(getLiveStreamingRetriever(cfg, dict, timeZoneObservable));
    }
    return retrievers;
};
var getSportsRetriever = function (cfg, timeZoneObservable) {
    switch (cfg.query) {
        case queryType.live:
            return getLiveSportsRetriever(cfg);
        case queryType.preLive:
            return getPreLiveSportsRetriever(cfg);
        case queryType.today:
            return getTodaySportRetriever(cfg, timeZoneObservable);
    }
};
var getLiveStreamingRetriever = function (cfg, dict, timeZoneObservable) {
    var baseRetriever = new LiveStreamingBaseRetriever(getBffGateway(cfg), dict, cfg.liveStreamingUpdatePeriod, cfg.liveStreamingMode);
    switch (cfg.query) {
        case queryType.live:
            return new LiveStreamingRetriever(baseRetriever, liveLiveStreamingQueryFactory);
        case queryType.preLive:
            return new LiveStreamingRetriever(baseRetriever, function () { return upcomingLiveStreamingQueryFactory(new Date()); });
        case queryType.today:
            return new TodayLiveStreamingRetriever(baseRetriever, timeZoneObservable, new Clock(Date), todayLiveStreamingQueryFactory);
    }
};
var getLiveSportsRetriever = function (cfg) {
    var bffQueryFactory = liveSportBFFQueryFactory;
    var sportApiQueryFactory = liveSportApiQueryFactory(GlobalConfig.apiConfigs.locale);
    var countMapper = liveCountMapper;
    var sportMapper = sportMapperFactory(countMapper, cfg.sportOrder);
    var sportsMapper = new SportsMapper(sportMapper);
    var sportPushesRetriever = new SportPushesRetriever(sportsMapper, countMapper, new SportDataGateway());
    var baseRetriever = new SportsBaseRetriever(getBffGateway(cfg), sportsMapper, sportPushesRetriever, cfg.sportRetrieverUpdatePeriod);
    return new SportsRetriever(baseRetriever, bffQueryFactory, sportApiQueryFactory);
};
var getMessageBus = function () { return new MessageBus(internalMessageBus); };
var getPreLiveSportsRetriever = function (cfg) {
    var bffQueryFactory = preLiveSportBFFQueryFactoryConstructor(Date);
    var sportApiQueryFactory = preLiveSportApiQueryFactory(GlobalConfig.apiConfigs.locale, Date);
    var countMapper = preLiveCountMapper;
    var sportMapper = sportMapperFactory(countMapper, cfg.sportOrder);
    var sportsMapper = new SportsMapper(sportMapper);
    var sportPushesRetriever = new SportPushesRetriever(sportsMapper, countMapper, new SportDataGateway());
    var baseRetriever = new SportsBaseRetriever(getBffGateway(cfg), sportsMapper, sportPushesRetriever, cfg.sportRetrieverUpdatePeriod);
    return new SportsRetriever(baseRetriever, bffQueryFactory, sportApiQueryFactory);
};
var getTodaySportRetriever = function (cfg, timeZoneObservable) {
    var countMapper = todayCountMapper;
    var sportMapper = sportMapperFactory(countMapper, cfg.sportOrder);
    var sportsMapper = new SportsMapper(sportMapper);
    var sportPushesRetriever = new SportPushesRetriever(sportsMapper, countMapper, new SportDataGateway());
    var baseRetriever = new SportsBaseRetriever(getBffGateway(cfg), sportsMapper, sportPushesRetriever, cfg.sportRetrieverUpdatePeriod);
    var sportApiQueryFactory = todaySportApiQueryFactory(GlobalConfig.apiConfigs.locale);
    return new TodaySportsRetriever(baseRetriever, timeZoneObservable, new Clock(Date), todaySportBFFQueryFactory, sportApiQueryFactory);
};
var isFavoritesShouldBeSelected = function (cfg) {
    return cfg.isFavoritesFirst && cfg.enableFavorites && !isLiveStreamingShouldBeSelected(cfg);
};
var isLiveStreamingShouldBeSelected = function (cfg) {
    return cfg.enableLiveStreaming && cfg.liveStreamingMode === liveStreamingMode.firstSelected;
};
var getSelectedSportByConfig = function (cfg) {
    if (isFavoritesShouldBeSelected(cfg)) {
        return defaultItemForSportMode.favorites;
    }
    if (isLiveStreamingShouldBeSelected(cfg)) {
        return defaultItemForSportMode.liveStreaming;
    }
    return defaultItemForSportMode.firstSport;
};
export var sportsParserFactory = function (cfg, retrievers) {
    return new SportParser(retrievers, getMessageBus(), cfg.blockId);
};
export var sportsStateFactory = function (cfg) {
    var messageSender = new MessageSender(getMessageBus(), cfg.blockId);
    return new State(messageSender, cfg.blockId, getSelectedSportByConfig(cfg));
};
var getBffGateway = function (cfg) { return new BFFGateway().withBlockId(cfg.blockId); };
//# sourceMappingURL=factories.js.map